
<j-process-node-group
    ref="root"
    :source="node"
    v-on="$listeners"
    :configs="configs">
    <j-icon :configs="imageConfig"></j-icon>
    <!-- <j-text :configs="{
        fontSize: '12px',
        textColor: '#000',
        content: node.name,
    }">
    </j-text> -->
    <!-- <j-group   
        :configs="configs"
        @afterResolveMovingTarget="prepareLink"
        @instancemousemove="setCrossHairCursor">
        <j-icon :configs="imageConfig"></j-icon>
    </j-group> -->
</j-process-node-group>
